import React, { useEffect, useState } from "react";
import { QuestionProps } from "../survey";
import nextId from "react-id-generator";
import InputQuestionWrapper from "../../components/base_ui/higher_order_components/questions/input_question_wrapper";

export interface Customizations {
  prompt: string;
  description?: string;
  placeholder?: string;
  optional?: boolean;
}

export type Answer = string;

export default function SurveyQuestionTextInput({
  customizations,
  currentAnswer,
  updateAnswer,
  setAbleToSubmit,
  showValidation,
}: QuestionProps<Answer, Customizations>) {
  const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);
  const [touched, setTouched] = useState<boolean>(false);

  // Hardcoded to for now, ideally this would be passed in from the backend.
  const maxCharacterCount = 100;

  const label = customizations.prompt;
  const id = "open-response-" + nextId();
  const description = customizations.description;
  const placeholder = customizations.placeholder;
  const optional = typeof customizations.optional === "undefined" ? false : customizations.optional;

  const hasNoOptionalityError =
    optional || (typeof currentAnswer !== "undefined" && currentAnswer !== "");
  const hasNoLengthError = (currentAnswer?.length || 0) <= maxCharacterCount;

  useEffect(() => {
    if (!hasNoOptionalityError) {
      setErrorMessage("Please complete the required field.");
      setAbleToSubmit(false);
    } else if (!hasNoLengthError) {
      setErrorMessage("Please shorten your response.");
      setAbleToSubmit(false);
    } else {
      setErrorMessage(undefined);
      setAbleToSubmit(true);
    }
  }, [hasNoOptionalityError, hasNoLengthError, setAbleToSubmit]);

  return (
    <InputQuestionWrapper
      dataTest="text-input"
      id={id}
      label={label}
      secondaryText={description}
      optional={optional}
      placeholder={placeholder}
      currentCharacterCount={currentAnswer?.length || 0}
      maxCharacterCount={maxCharacterCount}
      value={currentAnswer}
      onChange={({ currentTarget: { value: updatedResponse } }) => {
        updateAnswer(updatedResponse);
      }}
      onBlur={() => {
        setTouched(true);
      }}
      errorMessage={touched || showValidation ? errorMessage : undefined}
    />
  );
}
